import RequirementsManager from "../../../components/JobDescription/RequirementsManager";
import Typography from "../../../components/Typography";
import Blob from "../../../components/common/Blob";

function JEEndorsements() {
    return <RequirementsManager />;
}

export default JEEndorsements;
